var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLocaleEnUs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "MuiSvgIcon-root MuiSvgIcon-fontSizeMedium MuiBox-root",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.25 3H3.75C2.09315 3 0.75 4.34315 0.75 6V18C0.75 19.6569 2.09315 21 3.75 21H20.25C21.9069 21 23.25 19.6569 23.25 18V6C23.25 4.34315 21.9069 3 20.25 3Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.22656 4.3845H22.7696C22.2363 3.5535 21.3093 3 20.2481 3H3.74806C2.68756 3 1.76056 3.5535 1.22656 4.3845Z",
    fill: "#A62842"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5225 5.76904C1.5165 5.84629 1.5 5.92054 1.5 6.00004V7.15429H23.25V6.00004C23.25 5.92129 23.2335 5.84704 23.2275 5.76904H1.5225Z",
    fill: "#A62842"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 8.53857H23.25V9.92307H1.5V8.53857Z",
    fill: "#A62842"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 11.3076H23.25V12.6921H1.5V11.3076Z",
    fill: "#A62842"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 14.0767H23.25V15.4612H0.75V14.0767Z",
    fill: "#A62842"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 18C0.75 18.0787 0.76725 18.153 0.77325 18.231H23.2267C23.2327 18.1537 23.25 18.0795 23.25 18V16.8457H0.75V18Z",
    fill: "#A62842"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7696 19.6157H1.22656C1.75981 20.4467 2.68681 21.0002 3.74806 21.0002H20.2481C21.3086 21.0002 22.2356 20.4467 22.7696 19.6157Z",
    fill: "#A62842"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 3H12V12.6923H0.75V6C0.75 4.344 2.094 3 3.75 3Z",
    fill: "#102D5E"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M3.45244 5.59717L3.89644 5.27467H3.34819L3.17869 4.75342L3.00919 5.27467H2.46094L2.90419 5.59717L2.73469 6.11842L3.17869 5.79667L3.62194 6.11842L3.45244 5.59717Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M5.68681 5.59717L6.13081 5.27467H5.58256L5.41306 4.75342L5.24356 5.27467H4.69531L5.13856 5.59717L4.96906 6.11842L5.41306 5.79667L5.85631 6.11842L5.68681 5.59717Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M7.92194 5.59717L8.36519 5.27467H7.81694L7.64744 4.75342L7.47794 5.27467H6.92969L7.37294 5.59717L7.20419 6.11842L7.64744 5.79667L8.09069 6.11842L7.92194 5.59717Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M4.55009 6.9624L4.99409 6.64065H4.44584L4.27634 6.11865L4.10684 6.64065H3.55859L4.00184 6.9624L3.83234 7.4844L4.27634 7.1619L4.71959 7.4844L4.55009 6.9624Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M6.78522 6.9624L7.22847 6.64065H6.68022L6.51072 6.11865L6.34122 6.64065H5.79297L6.23622 6.9624L6.06747 7.4844L6.51072 7.1619L6.95397 7.4844L6.78522 6.9624Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M9.01959 6.9624L9.46284 6.64065H8.91459L8.74509 6.11865L8.57559 6.64065H8.02734L8.47134 6.9624L8.30184 7.4844L8.74509 7.1619L9.18909 7.4844L9.01959 6.9624Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M4.55009 9.69287L4.99409 9.37037H4.44584L4.27634 8.84912L4.10684 9.37037H3.55859L4.00184 9.69287L3.83234 10.2141L4.27634 9.89237L4.71959 10.2141L4.55009 9.69287Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M6.78522 9.69287L7.22847 9.37037H6.68022L6.51072 8.84912L6.34122 9.37037H5.79297L6.23622 9.69287L6.06747 10.2141L6.51072 9.89237L6.95397 10.2141L6.78522 9.69287Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M9.01959 9.69287L9.46284 9.37037H8.91459L8.74509 8.84912L8.57559 9.37037H8.02734L8.47134 9.69287L8.30184 10.2141L8.74509 9.89237L9.18909 10.2141L9.01959 9.69287Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1524 5.59717L10.5957 5.27467H10.0474L9.87791 4.75342L9.70841 5.27467H9.16016L9.60416 5.59717L9.43466 6.11842L9.87791 5.79667L10.3219 6.11842L10.1524 5.59717Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M3.45244 8.32812L3.89644 8.00562H3.34819L3.17869 7.48438L3.00919 8.00562H2.46094L2.90419 8.32812L2.73469 8.84937L3.17869 8.52688L3.62194 8.84937L3.45244 8.32812Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M5.68681 8.32812L6.13081 8.00562H5.58256L5.41306 7.48438L5.24356 8.00562H4.69531L5.13856 8.32812L4.96906 8.84937L5.41306 8.52688L5.85631 8.84937L5.68681 8.32812Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M7.92194 8.32812L8.36519 8.00562H7.81694L7.64744 7.48438L7.47794 8.00562H6.92969L7.37294 8.32812L7.20419 8.84937L7.64744 8.52688L8.09069 8.84937L7.92194 8.32812Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1524 8.32812L10.5957 8.00562H10.0474L9.87791 7.48438L9.70841 8.00562H9.16016L9.60416 8.32812L9.43466 8.84937L9.87791 8.52688L10.3219 8.84937L10.1524 8.32812Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M3.45244 11.0581L3.89644 10.7364H3.34819L3.17869 10.2144L3.00919 10.7364H2.46094L2.90419 11.0581L2.73469 11.5801L3.17869 11.2576L3.62194 11.5801L3.45244 11.0581Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M5.68681 11.0581L6.13081 10.7364H5.58256L5.41306 10.2144L5.24356 10.7364H4.69531L5.13856 11.0581L4.96906 11.5801L5.41306 11.2576L5.85631 11.5801L5.68681 11.0581Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M7.92194 11.0581L8.36519 10.7364H7.81694L7.64744 10.2144L7.47794 10.7364H6.92969L7.37294 11.0581L7.20419 11.5801L7.64744 11.2576L8.09069 11.5801L7.92194 11.0581Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1524 11.0581L10.5957 10.7364H10.0474L9.87791 10.2144L9.70841 10.7364H9.16016L9.60416 11.0581L9.43466 11.5801L9.87791 11.2576L10.3219 11.5801L10.1524 11.0581Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLocaleEnUs);
export default __webpack_public_path__ + "static/media/icon-locale-en-US.05ca79da8c4f879fa81b74aed0f43f45.svg";
export { ForwardRef as ReactComponent };